var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.4993C13.1066 12.4993 15.625 10.0742 15.625 7.08268C15.625 4.09114 13.1066 1.66602 10 1.66602C6.8934 1.66602 4.375 4.09114 4.375 7.08268C4.375 10.0742 6.8934 12.4993 10 12.4993Z",
    stroke: "#30BEAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26613 11.2672L6.25781 17.4172C6.25781 18.1672 6.78282 18.5339 7.43282 18.2255L9.66614 17.1672C9.84948 17.0755 10.1578 17.0755 10.3411 17.1672L12.5828 18.2255C13.2245 18.5255 13.7578 18.1672 13.7578 17.4172V11.1172",
    stroke: "#30BEAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.5f779d5eed10c52743a8e819fedde07d.svg";
export { ForwardRef as ReactComponent };